import axiosInstance from "./axiosConfigs";
import { AxiosRequestConfig } from "axios";
import constants from "config/constants";
import { KEYCLOAK_SCOPE } from "keycloak";
import { setAuthoriseSuccess } from "store/authorisation";
import store from "store/store";
import {
    axiosLikeFetch,
    AxiosLikeResponse,
    KeycloakResponse,
} from "utils/common";

export const getUser = async (
    config: AxiosRequestConfig = {
        params: { IncludeFavorites: true },
    },
    data = {}
): Promise<BokaMera.User> => {
    try {
        return axiosInstance
            .request({
                url: "/users",
                method: "GET",
                ...config,
                baseURL: config.baseURL
                    ? config.baseURL
                    : constants.BACKEND_URL,
                data,
                params:
                    config.method?.toLowerCase() === "get"
                        ? data
                        : config.params
                        ? config.params
                        : {},
            })
            .then((res) => {
                store.dispatch(setAuthoriseSuccess());
                return res.data;
            });
    } catch (err) {
        throw err;
    }
};

export const getCompanies = async (
    config: AxiosRequestConfig = {},
    data = {}
): Promise<BokaMera.Companies> => {
    try {
        return axiosInstance
            .request({
                url: `/companies`,
                method: "get",
                ...config,
                baseURL: config.baseURL
                    ? config.baseURL
                    : constants.BACKEND_URL,
                data,
                params:
                    config.method?.toLowerCase() === "get"
                        ? data
                        : config.params
                        ? config.params
                        : {},
            })
            .then((res) => {
                store.dispatch(setAuthoriseSuccess());
                return res.data;
            });
    } catch (err) {
        throw err;
    }
};

export const getCustomers = async (
    config: AxiosRequestConfig = {},
    data = {}
): Promise<BokaMera.Customers> => {
    try {
        return axiosInstance
            .request({
                url: `/customers`,
                method: "get",
                ...config,
                baseURL: config.baseURL
                    ? config.baseURL
                    : constants.BACKEND_URL,
                data,
                params:
                    config.method?.toLowerCase() === "get"
                        ? data
                        : config.params
                        ? config.params
                        : {},
            })
            .then((res) => {
                store.dispatch(setAuthoriseSuccess());
                return res.data;
            });
    } catch (err) {
        throw err;
    }
};

export const getResources = async (
    config: AxiosRequestConfig = {},
    data = {}
): Promise<BokaMera.Resources> => {
    try {
        const requestOptions: any = {
            url: `/resource`,
            method: "get",
            baseURL: config.baseURL ? config.baseURL : constants.BACKEND_URL,
        };

        if (data && JSON.stringify(data) !== "{}") {
            requestOptions.data = data;
        }

        if (
            config.method?.toLowerCase() === "get" &&
            data &&
            JSON.stringify(data) !== "{}"
        ) {
            requestOptions.params = data;
        }

        if (config?.params && JSON.stringify(config.params) !== "{}") {
            requestOptions.params = config.params;
        }

        return axiosInstance
            .request(requestOptions)
            .then((res) => res.data)
            .catch((err) => {
                // TODO: handle test failing
                // might be this a problem in the app too?
            });
    } catch (err) {
        throw err;
    }
};

export const getLicenses = async (
    config: AxiosRequestConfig = {},
    data = {}
): Promise<BokaMera.Licences> => {
    try {
        return axiosInstance
            .request({
                url: "/licenses/company",
                method: "get",
                ...config,
                baseURL: config.baseURL
                    ? config.baseURL
                    : constants.BACKEND_URL,
                data,
                params:
                    config.method?.toLowerCase() === "get"
                        ? data
                        : config.params
                        ? config.params
                        : {},
            })
            .then((res) => {
                store.dispatch(setAuthoriseSuccess());
                return res.data;
            });
    } catch (err) {
        throw err;
    }
};

export const getBookings = async (
    config: AxiosRequestConfig = {},
    data = {}
): Promise<BokaMera.Bookings | BokaMera.BookingsWithCustomer> => {
    try {
        return axiosInstance
            .request({
                url: `/bookings`,
                method: "get",
                ...config,
                baseURL: config.baseURL
                    ? config.baseURL
                    : constants.BACKEND_URL,
                data,
                params:
                    config.method?.toLowerCase() === "get"
                        ? data
                        : config.params
                        ? config.params
                        : {},
            })
            .then((res) => {
                store.dispatch(setAuthoriseSuccess());
                return res.data;
            });
    } catch (err) {
        throw err;
    }
};

export const getLicenseTypes = async (
    config: AxiosRequestConfig = {},
    data = {}
): Promise<BokaMera.LicenseTypes> => {
    try {
        return axiosInstance
            .request({
                url: `/licenses/types`,
                method: "get",
                ...config,
                baseURL: config.baseURL
                    ? config.baseURL
                    : constants.BACKEND_URL,
                data,
                params:
                    config.method?.toLowerCase() === "get"
                        ? data
                        : config.params
                        ? config.params
                        : {},
            })
            .then((res) => {
                store.dispatch(setAuthoriseSuccess());
                return res.data;
            });
    } catch (err) {
        throw err;
    }
};

export const getVersion = async (
    config: AxiosRequestConfig = {},
    data = {}
): Promise<any> => {
    return axiosInstance
        .request({
            baseURL: `${window.location.origin}`,
            url: "/version.json",
            method: "GET",
        })
        .then((res) => res.data);
};

export const createLicense = async (
    config: AxiosRequestConfig = {},
    data = {}
): Promise<BokaMera.Licence> => {
    try {
        return axiosInstance
            .request({
                url: `/licenses/company`,
                method: "post",
                ...config,
                baseURL: config.baseURL
                    ? config.baseURL
                    : constants.BACKEND_URL,
                data,
                params:
                    config.method?.toLowerCase() === "get"
                        ? data
                        : config.params
                        ? config.params
                        : {},
            })
            .then((res) => {
                store.dispatch(setAuthoriseSuccess());
                return res.data;
            });
    } catch (err) {
        throw err;
    }
};

export const cancelLicense = async (
    config: AxiosRequestConfig = {},
    data = {}
): Promise<BokaMera.Licence> => {
    try {
        return axiosInstance
            .request({
                url: `/licenses/company`,
                method: "delete",
                ...config,
                baseURL: config.baseURL
                    ? config.baseURL
                    : constants.BACKEND_URL,
                data,
                params:
                    config.method?.toLowerCase() === "get"
                        ? data
                        : config.params
                        ? config.params
                        : {},
            })
            .then((res) => {
                store.dispatch(setAuthoriseSuccess());
                return res.data;
            });
    } catch (err) {
        throw err;
    }
};

export const createBooking = async (
    config: AxiosRequestConfig = {},
    data = {}
): Promise<BokaMera.Booking> => {
    try {
        return axiosInstance
            .request({
                url: `/bookings`,
                method: "post",
                ...config,
                baseURL: config.baseURL
                    ? config.baseURL
                    : constants.BACKEND_URL,
                data,
                params:
                    config.method?.toLowerCase() === "get"
                        ? data
                        : config.params
                        ? config.params
                        : {},
            })
            .then((res) => {
                store.dispatch(setAuthoriseSuccess());
                return res.data;
            });
    } catch (err) {
        throw err;
    }
};

export const createTimeException = async (
    config: AxiosRequestConfig = {},
    data = {}
): Promise<BokaMera.TimeException> => {
    try {
        return axiosInstance
            .request({
                url: `/timeexceptions`,
                method: "post",
                ...config,
                baseURL: config.baseURL
                    ? config.baseURL
                    : constants.BACKEND_URL,
                data,
                params:
                    config.method?.toLowerCase() === "get"
                        ? data
                        : config.params
                        ? config.params
                        : {},
            })
            .then((res) => {
                store.dispatch(setAuthoriseSuccess());
                return res.data;
            });
    } catch (err) {
        throw err;
    }
};

export const unbookException = async (
    config: AxiosRequestConfig = {},
    data = {}
): Promise<any> => {
    try {
        return axiosInstance
            .request({
                url: `/timeexceptions`,
                method: "post",
                ...config,
                baseURL: config.baseURL
                    ? config.baseURL
                    : constants.BACKEND_URL,
                data,
                params:
                    config.method?.toLowerCase() === "get"
                        ? data
                        : config.params
                        ? config.params
                        : {},
            })
            .then((res) => {
                store.dispatch(setAuthoriseSuccess());
                return res.data;
            });
    } catch (err) {
        throw err;
    }
};

export const createDirectBook = async (
    config: AxiosRequestConfig = {},
    data = {}
): Promise<BokaMera.Booking> => {
    try {
        return axiosInstance
            .request({
                url: `/bookings/repeat`,
                method: "post",
                ...config,
                baseURL: config.baseURL
                    ? config.baseURL
                    : constants.BACKEND_URL,
                data,
                params:
                    config.method?.toLowerCase() === "get"
                        ? data
                        : config.params
                        ? config.params
                        : {},
            })
            .then((res) => {
                store.dispatch(setAuthoriseSuccess());
                return res.data;
            });
    } catch (err) {
        throw err;
    }
};

export const unbook = async (
    config: AxiosRequestConfig = {},
    data = {}
): Promise<BokaMera.Booking> => {
    try {
        return axiosInstance
            .request({
                url: `/bookings/repeat`,
                method: "post",
                ...config,
                baseURL: config.baseURL
                    ? config.baseURL
                    : constants.BACKEND_URL,
                data,
                params:
                    config.method?.toLowerCase() === "get"
                        ? data
                        : config.params
                        ? config.params
                        : {},
            })
            .then((res) => {
                store.dispatch(setAuthoriseSuccess());
                return res.data;
            });
    } catch (err) {
        throw err;
    }
};

export const getBillingInformation = async (
    config: AxiosRequestConfig = {},
    data = {}
): Promise<BokaMera.BillingInformation> => {
    try {
        return axiosInstance
            .request({
                url: `/billing/company`,
                method: "get",
                ...config,
                baseURL: config.baseURL
                    ? config.baseURL
                    : constants.BACKEND_URL,
                data,
                params:
                    config.method?.toLowerCase() === "get"
                        ? data
                        : config.params
                        ? config.params
                        : {},
            })
            .then((res) => {
                store.dispatch(setAuthoriseSuccess());
                return res.data;
            });
    } catch (err) {
        throw err;
    }
};

export const getAvailableTimes = async (
    config: AxiosRequestConfig = {},
    data = {}
): Promise<BokaMera.AvailableTimes> => {
    try {
        return axiosInstance
            .request({
                url: `/billing/company`,
                method: "get",
                ...config,
                baseURL: config.baseURL
                    ? config.baseURL
                    : constants.BACKEND_URL,
                data,
                params:
                    config.method?.toLowerCase() === "get"
                        ? data
                        : config.params
                        ? config.params
                        : {},
            })
            .then((res) => {
                store.dispatch(setAuthoriseSuccess());
                return res.data;
            });
    } catch (err) {
        throw err;
    }
};

export const getNextFreeTime = async (
    config: AxiosRequestConfig = {},
    data = {}
): Promise<BokaMera.FreeTime> => {
    try {
        return axiosInstance
            .request({
                url: `/services`,
                method: "get",
                ...config,
                baseURL: config.baseURL
                    ? config.baseURL
                    : constants.BACKEND_URL,
                data,
                params:
                    config.method?.toLowerCase() === "get"
                        ? data
                        : config.params
                        ? config.params
                        : {},
            })
            .then((res) => {
                store.dispatch(setAuthoriseSuccess());
                return res.data;
            });
    } catch (err) {
        throw err;
    }
};

export const getServices = async (
    config: AxiosRequestConfig = {},
    data = {}
): Promise<BokaMera.Services> => {
    try {
        return axiosInstance
            .request({
                url: `/services`,
                method: "get",
                ...config,
                baseURL: config.baseURL
                    ? config.baseURL
                    : constants.BACKEND_URL,
                data,
                params:
                    config.method?.toLowerCase() === "get"
                        ? data
                        : config.params
                        ? config.params
                        : {},
            })
            .then((res) => {
                store.dispatch(setAuthoriseSuccess());
                return res.data;
            });
    } catch (err) {
        throw err;
    }
};

export const getTimeExceptions = async (
    config: AxiosRequestConfig = {},
    data = {}
): Promise<BokaMera.TimeExceptions> => {
    try {
        return axiosInstance
            .request({
                url: `/timeexceptions`,
                method: "get",
                ...config,
                baseURL: config.baseURL
                    ? config.baseURL
                    : constants.BACKEND_URL,
                data,
                params:
                    config.method?.toLowerCase() === "get"
                        ? data
                        : config.params
                        ? config.params
                        : {},
            })
            .then((res) => {
                store.dispatch(setAuthoriseSuccess());
                return res.data;
            });
    } catch (err) {
        throw err;
    }
};

export const sendEmail = async (
    config: AxiosRequestConfig = {},
    data = {}
): Promise<any> => {
    try {
        return axiosInstance
            .request({
                url: `/messages/sendemailtocompany`,
                method: "post",
                ...config,
                baseURL: config.baseURL
                    ? config.baseURL
                    : constants.BACKEND_URL,
                data,
                params:
                    config.method?.toLowerCase() === "get"
                        ? data
                        : config.params
                        ? config.params
                        : {},
            })
            .then((res) => {
                store.dispatch(setAuthoriseSuccess());
                return res.data;
            });
    } catch (err) {
        throw err;
    }
};

export const getAccessToken = async (
    offlineToken: string
): Promise<AxiosLikeResponse<KeycloakResponse>> => {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

    var urlencoded = new URLSearchParams();
    urlencoded.append(
        "client_id",
        process.env.REACT_APP_KEYCLOAK_CLIENT_ID as string
    );

    // TODO: OFFLINE TOKEN LOGIC do we need here the offline token grant type?
    urlencoded.append("grant_type", "refresh_token");
    urlencoded.append("refresh_token", offlineToken);
    urlencoded.append("scope", KEYCLOAK_SCOPE);

    var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: urlencoded,
        redirect: "follow",
    };

    return axiosLikeFetch(
        `${process.env.REACT_APP_KEYCLOAK_AUTH_URL}/realms/${process.env.REACT_APP_KEYCLOAK_REALM}/protocol/openid-connect/token`,
        requestOptions as any
    );
};
